export default __webpack_public_path__ + "static/media/img1.638e4eec.png";